import axios from 'axios';

export default {
    name: 'administrator',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getIntervalWorkflow(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "interval_workflow",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        putIntervalWorkflow(store, { auth, data }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "put",
                    url: process.env.VUE_APP_SERVICEURL + "interval_workflow",
                    data: data,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    }
}